"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var future_1 = require("./future");
var logger_1 = require("./logger");
/**
 * Given task options, creates the task logger
 *
 * It will prefix taskName to the logs
 */
var createTaskLogger = function (opts) {
    if (opts.logger) {
        return logger_1.prefixLogger(opts.name, opts.logger);
    }
    else {
        return logger_1.noopLogger;
    }
};
/**
 * Runs an async function eternally until stopped
 *
 * @param fn function to run
 */
function repeatTask(opts, fn) {
    var _this = this;
    var logger = createTaskLogger(opts);
    var isActive = true;
    var ctx = {
        executionNumber: 0,
        stopTask: function () {
            isActive = false;
        },
    };
    var loop = function () { return __awaiter(_this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isActive) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    ctx.executionNumber++;
                    return [4 /*yield*/, fn(ctx)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    logger("Failed with error: " + err_1.message);
                    logger(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    if (isActive) {
                        setTimeout(loop, opts.timeInBetweenMS);
                    }
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (opts.initialDelayMS != null) {
        setTimeout(loop, opts.initialDelayMS);
    }
    else {
        // tslint:disable-next-line: no-floating-promises
        loop();
    }
    return {
        stop: ctx.stopTask,
        isRunning: function () {
            return isActive;
        },
    };
}
exports.repeatTask = repeatTask;
function conditionWatcher(opts) {
    var _this = this;
    return repeatTask(opts, function (ctx) { return __awaiter(_this, void 0, void 0, function () {
        var val;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, opts.pollCondition()];
                case 1:
                    val = _a.sent();
                    if (!val) return [3 /*break*/, 3];
                    ctx.stopTask();
                    return [4 /*yield*/, opts.onSuccess()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
exports.conditionWatcher = conditionWatcher;
function tryObtainValueWithRetries(opts) {
    var _this = this;
    var futureValue = new future_1.Future();
    var task = repeatTask(opts, function (ctx) { return __awaiter(_this, void 0, void 0, function () {
        var val;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(ctx.executionNumber > opts.maxAttemps)) return [3 /*break*/, 1];
                    ctx.stopTask();
                    futureValue.reject(new Error('Max Retries & no value'));
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, opts.tryGetValue()];
                case 2:
                    val = _a.sent();
                    if (val != null) {
                        futureValue.resolve(val);
                        ctx.stopTask();
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); });
    return __assign(__assign({}, task), { stop: function () {
            task.stop();
            futureValue.reject(new Error('Cancelled'));
        }, onValue: function () { return futureValue.asPromise(); } });
}
exports.tryObtainValueWithRetries = tryObtainValueWithRetries;
//# sourceMappingURL=task.js.map